import * as React from "react";
import CVPositionDescription from "./position-description";
import { Position } from "../../data/cv-data";

interface IPositionBlockProps {
  position: Position;
  nextPosition?: Position;
  showResponsibilities?: boolean;
  showAchievements?: boolean;
  showProjects?: boolean;
}

const PositionBlock: React.FunctionComponent<IPositionBlockProps> = ({
  position,
  nextPosition,
  showResponsibilities,
  showAchievements,
  showProjects,
}) => {

  const isLastOverall =
    typeof nextPosition === "undefined" || nextPosition === null;
  let intermediateYears: number[] = [];
  if (!isLastOverall) {
    const currentStartYear = parseInt(position.period.split(" - ")[1]);
    const nextStartYear = parseInt(nextPosition.period.split(" - ")[1]);

    if (!isNaN(currentStartYear) && !isNaN(nextStartYear)) {
      for (let year = currentStartYear; year > nextStartYear; year--) {
        intermediateYears.push(year);
      }
    } else if (!isNaN(nextStartYear)) {
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year > nextStartYear; year--) {
        intermediateYears.push(year);
      }
    }
  }

  return (
    <section
      id={position.id}
      className="relative flex gap-[15px] scroll-mt-[20px]"
    >
      {/* Timeline */}
      <div className="relative flex w-[60px] shrink-0 flex-col items-center pt-[8px]">
        <div className="z-10 h-[12px] w-[12px] shrink-0 rounded-full border-[3px] border-white bg-[#334155] ring-2 ring-[#334155]" />

        {!isLastOverall && (
          <div className="relative mt-[4px] flex min-h-[100px] flex-1 flex-col items-center justify-evenly">
            <div className="absolute inset-0 left-1/2 w-[2px] -translate-x-1/2 bg-[#cbd5e1]" />

            {intermediateYears.map((year) => (
              <div
                key={year}
                className="relative z-10 flex items-center gap-[8px] pr-[53px]"
              >
                <div className="w-[45px] text-right font-['Bitter',sans-serif] text-[12px] font-medium text-[#94a3b8]">
                  {year}
                </div>
                <div className="h-[2px] w-[6px] bg-[#94a3b8]" />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Date */}
      <div className="flex w-[80px] shrink-0 flex-col pt-[3px] hidden sm:hidden md:flex">
        <p className="font-['Bitter',sans-serif] text-[13px] font-normal text-[#64748b]">
          {position.period.split(" - ")[1]}
        </p>
        <p className="font-['Bitter',sans-serif] text-[13px] font-normal text-[#64748b]">
          {position.period.split(" - ")[0]}
        </p>
        <p className="mt-[2px] font-['Bitter',sans-serif] text-[11px] font-normal text-[#94a3b8]">
          {position.duration}
        </p>
      </div>

      {/* Content */}
      <CVPositionDescription
        position={position}
        showAchievements={showAchievements}
        showResponsibilities={showResponsibilities}
        showProjects={showProjects}
      />
    </section>
  );
};

export default PositionBlock;
